<template>
    <div>
        <!-- List header -->
        <a-row type="flex" :gutter="24">

            <a-col :span="12" class="mb-24"> 

			</a-col>

            <a-col :span="12" class="mb-24 text-right">
                <a-button @click="openMenuAddModal" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> ADD MENU
				</a-button>
            </a-col>

        </a-row>
        <!-- / List header -->

        <!-- List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
            <menus-list-view />
        </a-card>
        <!-- / List card -->

         <menu-add-view-modal ref="menuAddModal"/>
    </div>
</template>

<script>
import MenusListView from './MenusListView.vue'
import MenuAddViewModal from './MenuAddViewModal.vue'
import { OPEN_MENU_EDIT_VIEW_EVENT } from '../../../common/events/componentEvents.js'
export default {
    inject : ['eventBus'],
    components : {
        MenuAddViewModal,
        MenusListView
    },

    methods : {
        
        destroyComponent() {

        },

        openMenuAddModal() {
            this.$refs['menuAddModal'].showModal();
        },
        
        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },
    },

    data () {

        return {
            currentView : 'MenusListView'
        }
    },

    async created() {
        this.$message.loading('Loading data...', 0);
         await this.sleep(2000);
        await this.$store.dispatch('menus/getMenusAction', { });
        await this.$store.dispatch('menus/getItemsInRepositoryAction', { } );
        this.$message.destroy();
        
    },
    destroyed() {

    }
}

</script>

<style>

</style>